import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {NodeEntity} from "../../helpers/Entities/NodeEntity"
import CustomNodeComponentContext from "../CustomNodeComponentContext";

class Node extends Component
{
    static propTypes = {
        node: PropTypes.instanceOf(NodeEntity).isRequired,
        onClick: PropTypes.func.isRequired,
        current: PropTypes.bool,
        icons: PropTypes.objectOf(PropTypes.string),
        isBreadCrumb: PropTypes.bool,
    }

    static contextType = CustomNodeComponentContext;

    render()
    {
        const {node, onClick, current = false, icons = {}} = this.props

        const item = <span><i className={`fas ${node.icon(icons)}`} aria-hidden="true"/>{node.title}</span>

        if(current)
        {
            return (<li>{item}</li>)
        }

        if(!node.metadata.isEnable)
        {
            return (
                <li className="disabled">
                    <div className="node" title={node.title}>{item}</div>
                </li>
            )
        }

        let nodeComponent = <div className="node" onClick={onClick} title={node.title}>{item}</div>
        const CustomNode = this.context || null;
        if(CustomNode)
        {
            nodeComponent = <CustomNode onClick={onClick} node={node} item={item} isBreadCrumb={this.props.isBreadCrumb}></CustomNode>
        }

        return (
            <li>
                {nodeComponent}
            </li>
        )
    }
}

export default Node
